import { freeSet } from "@coreui/icons";

import { cuSygnet } from "./sygnet";
import { cuLogo } from "./logo";
import { cuLogoNegative } from "./logo-negative";

import {
  // aralab
  ltAdmin,
  ltHome,
  ltHistory,
  ltChamber,
  ltLog,
  ltRules,
  ltConfig,
  ltService,

  // viplant
  ltSite,

  // digidelta
  ltMachine1,
  ltPerformance,
  ltCalculations,
  ltTeamCenter,
  ltEbr,
  ltPlanning,

  // toolbox
  ltUp,
  ltDown,
  ltForward,
  ltBottom,
  ltDelete,
  ltUndo,
  ltRedo,
  ltDuplicate,
  ltLock,
  ltUnlock,
  ltDownload,
  ltCircle,
  ltRectangle,
  ltTriangle,
  ltButton,
  ltSwitch2,
  ltTextinput,
  ltOutput,
  ltInOut,
  ltZoomIn,
  ltZoomOut2,
  ltLed,
  ltElements,
  ltActions,
  ltLayers2,
  ltSearch,

  // canva icons
  ltLock2,
  ltLockCanva,
  ltUnlock2,
  ltUnlockCanva,
  ltTimeCanva,
  ltTime,
  ltTemp,
  ltTempCanva,
  ltEnergy2,
  ltEnergy2Canva,
  ltProcessing2,
  ltProcessingCanva,
  ltSend2,
  ltSendCanva,
  ltWater2,
  ltWaterCanva,
  ltFire2,
  ltFireCanva,
  ltPressure2,
  ltPressureCanva,
  ltDeploy2,
  ltDeployCanva,
  ltValve2,
  ltValveCanva,
  ltArrowRight2,
  ltArrowRightCanva,
  ltLevel2,
  ltLevelCanva,
  ltManual,
  ltManualCanva,
  ltWaterPump,
  ltWaterPumpVertical,
  ltWaterPumpCanva,
  ltWaterPumpVerticalCanva,
  ltSpeed,
  ltSpeedCanva,
  ltConfigurations,
  ltConfigCanva,
  ltGraph2,
  ltGraphCanva,
  ltCompressor,
  ltCompressorCanva,
  //
  ltRawMaterials,
  ltGroup,
  ltText,
  ltSignature,
  ltNumeric,
  ltNumber,
  ltInterface,
  ltMath,
  ltFields,
  ltSwitch,
  ltDate,
  ltChecklist,
  ltTitle,
  ltCreate,
  ltFollowup,
  ltStep,
  ltSection,
  ltDropdown,
  ltFileupload,
  ltUserinput,
  ltServicescosts,
  ltDynamicchecklist,
  ltTimeunit,
  ltTemperature,
  ltHumidity,
  ltBurner,
  ltMode,
  ltWindowside,
  ltWindowtop,
  ltShadow,
  ltGraph,
  ltWindSpeed,
  ltWindDir,
  ltRainRate,
  ltRaining,
  ltMobile,
  ltTablet,
  ltLaptop,
  ltDesktop,
  ltLargeDesktop,
  ltExtraLargeDesktop,
  ltSave,
  ltLayers,
  ltPencil,
  ltPlus,
  ltSeparator,
  ltOptions,
  ltClose,
  ltLevel,
  ltPressure,
  ltValve,
  ltFlow,
  ltCalendar,
  ltRecipe,
  ltMaintenace,
  ltQuality,
  ltMachine,
  ltMachine2,
  ltReporting,
  ltEnergy,
  ltProcessing,
  ltPending,
  ltSent,
  ltAcknowledge,
  ltDeployok,
  ltDeployNotok,
  ltCanceled,
  ltCancel,
  ltLeft,
  ltRight,
  ltEyeShow,
  ltEyeHide,
  ltDropdownIndicator,
  ltZoomOut,
  ltDew,
  ltAttachment,
  ltMenu,
  ltTableselect,
  ltSpareparts,
  ltPnctype,
  ltConsumables,
  ltTovalidate,
  ltQrcode,
  ltIconTest,

  //cisChevronLeft,
  ltMenuHead,
  ltBackHead,
  ltEditHead,
  ltSettingsHead,
  ltNotificationsHead,
  ltAddHead,
  ltSaveHead,
  ltDismissHead,
  ltDeleteHead,
  ltUserHead,
  ltLogoutHead,

  // Machines-colored
  ltHomeNavMain,
  ltPlanningNavMain,
  ltProductionNavMain,
  ltRecipeNavMain,
  ltRawMaterialsNavMain,
  ltMaintenanceNavMain,
  ltQualityNavMain,
  ltMachineNavMain,
  ltEBRNavMain,
  ltPerformanceNavMain,
  ltReportingNavMain,
  ltCalculationsNavMain,
  ltEnergyNavMain,
  ltEventsNavMain,
  ltTeamCenterNavMain,
  ltSettingsNavMain,
  ltInvoicesNavMain,
  ltExpensesMapNavMain,
  ltKMSMapNavMain,
  ltBankConciliationNavMain,
  ltContactsNavMain,
  ltVacationsNavMain,
  ltProjectsNavMain,
  ltUsersNavMain,
  ltAdminNavMain,

  // Machines-non-colored
  ltHomeNav,
  ltPlanningNav,
  ltProductionNav,
  ltRecipeNav,
  ltRawMaterialsNav,
  ltMaintenanceNav,
  ltQualityNav,
  ltMachineNav,
  ltEBRNav,
  ltPerformanceNav,
  ltReportingNav,
  ltCalculationsNav,
  ltEnergyNav,
  ltEventsNav,
  ltTeamCenterNav,
  ltSettingsNav,
  ltInvoicesNav,
  ltExpensesMapNav,
  ltKMSMapNav,
  ltBankConciliationNav,
  ltContactsNav,
  ltVacationsNav,
  ltProjectsNav,
  ltUsersNav,
  ltAdminNav,
  ltMore,

  // TestIOT - Colored
  ltStatusNavMain,
  ltHistoryNavMain,
  ltLiveNavMain,
  ltReportsNavMain,
  ltKnowledgeBaseNavMain,
  ltConfigurationsNavMain,
  ltMachinesNavMain,
  ltHMINavMain,
  ltLabellingNavMain,
  // TestIOT - non-Colored
  ltStatusNav,
  ltHistoryNav,
  ltLiveNav,
  ltReportsNav,
  ltKnowledgeBaseNav,
  ltConfigurationsNav,
  ltMachinesNav,
  ltHMINav,
  ltLabellingNav,

  //Coatinspeckt - colored icons
  ltCamerasNavMain,
  ltStatsNavMain,
  ltDefectsNavMain,
  ltDefectsAreaNavMain,
  ltDefectsTypesNavMain,
  ltLabelTypesNavMain,
  ltRulesNavMain,
  ltRecipesNavMain,
  ltProgramsNavMain,

  // Coatinspeckt - non-Colored
  ltCamerasNav,
  ltStatsNav,
  ltDefectsNav,
  ltDefectsAreaNav,
  ltDefectsTypesNav,
  ltLabelTypesNav,
  ltRulesNav,
  ltRecipesNav,
  ltProgramsNav,

  // Other new icons
  ltCardDefault,
  ltCards,
  ltFilterApplied,
  ltFilter,
  ltTrainingNav,
  ltModalInput,
  ltTrainingNavMain,
  ltStop,
  ltPlayCil,
  ltStopCil,
  ltReload,
  // Controls
  ltPlay,
  ltPause,
  ltNext,
  ltPrev,
  ltLoop,
  ltInfo,
  ltArrowRight,
  ltArrowLeft,
  ltProduction,
  ltProduct,
  ltPrint,
  ltClock,
  ltSample,
  ltFilterActive,
  ltSortDesc,
  ltSortAsc,
  ltLink,
  ltDoubleRight,
  ltEdit,
  ltFile,
  ltDrag,
} from "./lumitio";

export const icons = Object.assign(
  {},
  {
    ...freeSet,
  },
  {
    // aralab
    ltAdmin,
    ltHome,
    ltHistory,
    ltChamber,
    ltLog,
    ltRules,
    ltConfig,
    ltService,

    // viplant
    ltSite,

    // digidelta
    ltMachine1,
    ltPerformance,
    ltCalculations,
    ltTeamCenter,
    ltEbr,
    ltPlanning,
    //

    // toolbox
    ltUp,
    ltDown,
    ltForward,
    ltBottom,
    ltDelete,
    ltUndo,
    ltRedo,
    ltDuplicate,
    ltLock,
    ltUnlock,
    ltDownload,
    ltSearch,

    ltCircle,
    ltRectangle,
    ltTriangle,
    ltButton,
    ltSwitch2,
    ltTextinput,
    ltOutput,
    ltInOut,
    ltZoomIn,
    ltZoomOut2,
    ltLed,

    ltElements,
    ltActions,
    ltLayers2,

    // icons canvas
    ltLock2,
    ltLockCanva,
    ltUnlock2,
    ltUnlockCanva,
    ltTimeCanva,
    ltTime,
    ltTemp,
    ltTempCanva,
    ltEnergy2,
    ltEnergy2Canva,
    ltProcessing2,
    ltProcessingCanva,
    ltSend2,
    ltSendCanva,
    ltWater2,
    ltWaterCanva,
    ltFire2,
    ltFireCanva,
    ltPressure2,
    ltPressureCanva,
    ltDeploy2,
    ltDeployCanva,
    ltValve2,
    ltValveCanva,
    ltArrowRight2,
    ltArrowRightCanva,
    ltLevel2,
    ltLevelCanva,
    ltManual,
    ltManualCanva,
    ltWaterPump,
    ltWaterPumpVertical,
    ltWaterPumpCanva,
    ltWaterPumpVerticalCanva,
    ltSpeed,
    ltSpeedCanva,
    ltConfigurations,
    ltConfigCanva,
    ltGraph2,
    ltGraphCanva,
    ltCompressor,
    ltCompressorCanva,

    ltRawMaterials,
    ltGroup,
    ltText,
    ltSignature,
    ltNumeric,
    ltNumber,
    ltInterface,
    ltMath,
    ltFields,
    ltSwitch,
    ltDate,
    ltChecklist,
    ltTitle,
    ltCreate,
    ltFollowup,
    ltStep,
    ltSection,
    ltDropdown,
    ltFileupload,
    ltUserinput,
    ltServicescosts,
    ltDynamicchecklist,
    ltTimeunit,
    ltTemperature,
    ltHumidity,
    ltBurner,
    ltMode,
    ltWindowside,
    ltWindowtop,
    ltShadow,
    ltGraph,
    ltWindSpeed,
    ltWindDir,
    ltRainRate,
    ltRaining,
    ltMobile,
    ltTablet,
    ltLaptop,
    ltDesktop,
    ltLargeDesktop,
    ltExtraLargeDesktop,
    ltSave,
    ltLayers,
    ltPencil,
    ltPlus,
    ltSeparator,
    ltOptions,
    ltLeft,
    ltRight,
    ltEyeShow,
    ltEyeHide,
    ltDropdownIndicator,
    ltZoomOut,
    //cisChevronLeft,
    ltClose,
    ltLevel,
    ltPressure,
    ltValve,
    ltFlow,
    ltCalendar,
    ltRecipe,
    ltMaintenace,
    ltQuality,
    ltMachine,
    ltMachine2,
    ltReporting,
    ltEnergy,
    ltProcessing,
    ltPending,
    ltSent,
    ltAcknowledge,
    ltDeployok,
    ltDeployNotok,
    ltCanceled,
    ltCancel,
    ltDew,
    ltAttachment,
    ltMenu,
    ltTableselect,
    ltSpareparts,
    ltPnctype,
    ltConsumables,
    ltTovalidate,
    ltQrcode,
    ltIconTest,
    // New Header icons
    ltMenuHead,
    ltBackHead,
    ltEditHead,
    ltSettingsHead,
    ltNotificationsHead,
    ltAddHead,
    ltSaveHead,
    ltDismissHead,
    ltDeleteHead,
    ltUserHead,
    ltLogoutHead,
    // Machines - colored nav icons
    ltHomeNavMain,
    ltPlanningNavMain,
    ltProductionNavMain,
    ltRecipeNavMain,
    ltRawMaterialsNavMain,
    ltMaintenanceNavMain,
    ltQualityNavMain,
    ltMachineNavMain,
    ltEBRNavMain,
    ltPerformanceNavMain,
    ltReportingNavMain,
    ltCalculationsNavMain,
    ltEnergyNavMain,
    ltEventsNavMain,
    ltTeamCenterNavMain,
    ltSettingsNavMain,
    ltInvoicesNavMain,
    ltExpensesMapNavMain,
    ltKMSMapNavMain,
    ltBankConciliationNavMain,
    ltContactsNavMain,
    ltVacationsNavMain,
    ltProjectsNavMain,
    ltUsersNavMain,
    ltAdminNavMain,
    // Machines - non-colored
    ltHomeNav,
    ltPlanningNav,
    ltProductionNav,
    ltRecipeNav,
    ltRawMaterialsNav,
    ltMaintenanceNav,
    ltQualityNav,
    ltMachineNav,
    ltEBRNav,
    ltPerformanceNav,
    ltReportingNav,
    ltCalculationsNav,
    ltEnergyNav,
    ltEventsNav,
    ltTeamCenterNav,
    ltSettingsNav,
    ltInvoicesNav,
    ltExpensesMapNav,
    ltKMSMapNav,
    ltBankConciliationNav,
    ltContactsNav,
    ltVacationsNav,
    ltProjectsNav,
    ltUsersNav,
    ltAdminNav,

    // TestIOT - Colored
    ltStatusNavMain,
    ltHistoryNavMain,
    ltLiveNavMain,
    ltReportsNavMain,
    ltKnowledgeBaseNavMain,
    ltConfigurationsNavMain,
    ltMachinesNavMain,
    ltHMINavMain,
    ltTrainingNavMain,
    ltLabellingNavMain,
    // TestIOT - non-Colored
    ltStatusNav,
    ltTrainingNav,
    ltModalInput,
    ltHistoryNav,
    ltLiveNav,
    ltReportsNav,
    ltKnowledgeBaseNav,
    ltConfigurationsNav,
    ltMachinesNav,
    ltHMINav,
    ltLabellingNav,

    //Coatinspeckt - colored icons
    ltCamerasNavMain,
    ltStatsNavMain,
    ltDefectsNavMain,
    ltDefectsAreaNavMain,
    ltDefectsTypesNavMain,
    ltLabelTypesNavMain,
    ltRulesNavMain,
    ltRecipesNavMain,
    ltProgramsNavMain,

    // Coatinspeckt - non-Colored
    ltCamerasNav,
    ltStatsNav,
    ltDefectsNav,
    ltDefectsAreaNav,
    ltDefectsTypesNav,
    ltLabelTypesNav,
    ltRulesNav,
    ltRecipesNav,
    ltProgramsNav,

    // new icons
    ltMore,
    ltCardDefault,
    ltCards,
    ltFilterApplied,
    ltFilter,
    ltPlayCil,
    ltStopCil,
    ltReload,
    ltStop,
    ltLink,
    ltDoubleRight,
    ltEdit,
    ltFile,
    ltDrag,
    // Controls
    ltPlay,
    ltPause,
    ltNext,
    ltPrev,
    ltLoop,
    ltInfo,
    ltArrowRight,
    ltArrowLeft,

    ltProduction,
    ltProduct,
    ltPrint,
    ltClock,
    ltSample,
    ltFilterActive,
    ltSortDesc,
    ltSortAsc,
  },
  {
    cuSygnet,
    cuLogo,
    cuLogoNegative,
  },
);
